<template>
	<div class="home flex w-full flex-col">
		<HomeHeader 
			:show_language_modal="show_language_modal"
			:toggleLanguageModal="toggleLanguageModal"
		/>
		<HomeHero />
		<section
			v-if="apiStatus === 'idle'"
			id="home-menu"
			class="h-5/6 w-screen overflow-auto p-5 pt-0 md:overflow-hidden"
		>
			<HomeMenu
				:categories="categories || []"
		
				:getTranslations="getTranslations"
				:toTitleCase="toTitleCase"
			/>
		</section>
		<section
			v-if="apiStatus === 'busy'"
			class="flex grow items-center justify-center"
		>
			<LoaderDots :isLoading="apiStatus === 'busy'" />
		</section>
		<ErrorBlock
			:apiStatus="apiStatus"
			:errorMessage="errorMessage"
			:getTranslations="getTranslations"
		/>
		<HomeNewsletter />
		<HomeFooter />
	</div>
</template>

<script src="./HomeScreen.js"></script>
<style lang="scss" src="./HomeScreen.scss" scoped></style>
